import { render, staticRenderFns } from "./SliderWrapper.vue?vue&type=template&id=1082ca56&"
import script from "./SliderWrapper.vue?vue&type=script&lang=js&"
export * from "./SliderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1082ca56')) {
      api.createRecord('1082ca56', component.options)
    } else {
      api.reload('1082ca56', component.options)
    }
    module.hot.accept("./SliderWrapper.vue?vue&type=template&id=1082ca56&", function () {
      api.rerender('1082ca56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SliderWrapper.vue"
export default component.exports